/**
 * Application-wide constants
 */

/**
 * Featured snap that should appear at the top of every user's social feed.
 * This snap is automatically added to new users' feeds and displayed prominently.
 */
export const FEATURED_SNAP_ID = "794bc00b-d144-4840-aa04-e8ec5577fa67";

/**
 * Override image URL for the featured snap (replaces the original DB image).
 */
export const FEATURED_SNAP_IMAGE_URL = "/beforeaftertest.png";

/**
 * Promotional overlay image shown after the featured snap blurs.
 */
export const FEATURED_SNAP_OVERLAY_URL = "/iphone-screenshots/progress-snaps.png";
